module.exports = __webpack_public_path__ + "static/media/arrow-red.2f37e052.svg";